/* eslint-disable no-case-declarations */
import { EMPTY_ID } from '../constants';
import {
  getActiveSpaceService,
  getAllSpacesService,
  getSpaceStatusService,
  setActiveSpaceService,
  setSpaceStatusService,
} from '../services/contentService';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// async thunk
export const getAllSpaces = createAsyncThunk(
  'spaces/getAllSpaces',
  async () => {
    const response = await getAllSpacesService();
    return response.data;
  }
);

export const getActiveSpace = createAsyncThunk(
  'spaces/getActiveSpace',
  async () => {
    const response = await getActiveSpaceService();
    if (response.data === EMPTY_ID) {
      try {
        const response = await getAllSpacesService();
        return Object.keys(response.data)[0];
      } catch (error) {
        return response.data;
      }
    }
    return response.data;
  }
);

export const setActiveSpace = createAsyncThunk(
  'spaces/setActiveSpace',
  async (id) => {
    const response = await setActiveSpaceService(id);
    return response.data;
  }
);

export const getSpaceStatus = createAsyncThunk(
  'spaces/getSpaceStatus',
  async () => {
    const response = await getSpaceStatusService();
    return response.data;
  }
);

export const setSpaceStatus = createAsyncThunk(
  'spaces/setSpaceStatus',
  async (enable) => {
    const response = await setSpaceStatusService(enable);
    return response.data;
  }
);

// slice
const spacesSlice = createSlice({
  name: 'spaces',
  initialState: {
    spaces: {},
    activeSpaceId: '',
    enabled: false,
  },
  reducers: {
    removeSpace(state, action) {
      const { [action.payload]: value, ...withoutItem } = state.spaces;
      return { ...state, spaces: withoutItem };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllSpaces.pending, (state) => {
        console.log('Fetching all spaces...');
        return state;
      })
      .addCase(getAllSpaces.fulfilled, (state, action) => {
        return { ...state, spaces: action.payload };
      })
      .addCase(getAllSpaces.rejected, (action) => {
        console.error('Failed to fetch spaces:', action.error);
      })
      .addCase(getActiveSpace.pending, (state) => {
        console.log('Fetching active space...');
      })
      .addCase(getActiveSpace.fulfilled, (state, action) => {
        return { ...state, activeSpaceId: action.payload };
      })
      .addCase(getActiveSpace.rejected, (action) => {
        console.error('Failed to fetch active space:', action.error);
      })
      .addCase(setActiveSpace.pending, (state) => {
        console.log('Setting active space...');
      })
      .addCase(setActiveSpace.fulfilled, (state, action) => {
        return { ...state, activeSpaceId: action.meta.arg };
      })
      .addCase(setActiveSpace.rejected, (action) => {
        console.error('Failed to set active space:', action.error);
      })
      .addCase(getSpaceStatus.pending, (state) => {
        console.log('Fetching space status...');
      })
      .addCase(getSpaceStatus.fulfilled, (state, action) => {
        return { ...state, enabled: action.payload === 'Activated' };
      })
      .addCase(getSpaceStatus.rejected, (action) => {
        console.error('Failed to fetch space status:', action.error);
      })
      .addCase(setSpaceStatus.pending, (state) => {
        console.log('Setting space status...');
      })
      .addCase(setSpaceStatus.fulfilled, (state, action) => {
        return { ...state, enabled: action.meta.arg };
      })
      .addCase(setSpaceStatus.rejected, (action) => {
        console.error('Failed to set space status:', action.error);
      });
  },
});

export default spacesSlice.reducer;
export const { removeSpace } = spacesSlice.actions;
